import { useCallback } from 'react';
import { useImageActions, useImageState } from '@/contexts/ImageContext';

interface UseChatImageProps {
  index: number;
  messageId: string;
}

export function useChatImage({ index, messageId }: UseChatImageProps) {
  const { selectImage, deselectImage, hoverImage, stopHover } = useImageActions();
  const { isSelected, selectedImageMessageId } = useImageState();
  
  const handleImageClick = useCallback(() => {
    // If the clicked image is already selected, deselect it
    if (isSelected === index && selectedImageMessageId === messageId) {
      deselectImage();
    } else {
      selectImage(index, messageId);
    }
  }, [index, selectImage, deselectImage, isSelected, selectedImageMessageId, messageId]);

  const handleMouseOver = useCallback(() => {
    hoverImage(index, messageId);
  }, [index, hoverImage, messageId]);

  const handleMouseOut = useCallback(() => {
    stopHover();
  }, [stopHover]);


  return {
    handleImageClick,
    handleMouseOver,
    handleMouseOut,
  };
}
